import type { SVGProps } from '../types';

const EmptyTableNoResults = (props: SVGProps) => {
  const { title = 'Empty table no results', className, ...restProps } = props;

  return (
    <svg
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="230"
      height="185"
      viewBox="0 0 230 185"
      {...restProps}
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_554_35894)">
        <path
          d="M124.027 12.1306L123.895 21.5913"
          stroke="#5681F6"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M131.836 21.9938L137.611 12.0849"
          stroke="#5681F6"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M116.479 21.6055L110.756 11.6627"
          stroke="#5681F6"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M180.037 59.6288C182.123 59.6288 183.813 57.9416 183.813 55.8626C183.813 57.9416 185.503 59.6288 187.586 59.6288C185.499 59.6288 183.809 61.3161 183.809 63.395C183.809 61.3123 182.119 59.625 180.037 59.625V59.6288Z"
          fill="#5681F6"
        />
        <path
          d="M180.037 59.6288C182.123 59.6288 183.813 57.9416 183.813 55.8626C183.813 57.9416 185.503 59.6288 187.586 59.6288C185.499 59.6288 183.809 61.3161 183.809 63.395C183.809 61.3123 182.119 59.625 180.037 59.625V59.6288Z"
          stroke="#5681F6"
          strokeWidth="1.55738"
          strokeMiterlimit="10"
        />
        <path
          d="M187.304 44.6373C191.529 44.6373 194.954 41.2175 194.954 36.9994C194.954 41.2175 198.38 44.6373 202.605 44.6373C198.38 44.6373 194.954 48.057 194.954 52.2751C194.954 48.057 191.529 44.6373 187.304 44.6373Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M84.8346 21.7471C85.6325 21.7471 86.2794 21.1013 86.2794 20.3046C86.2794 19.508 85.6325 18.8622 84.8346 18.8622C84.0366 18.8622 83.3898 19.508 83.3898 20.3046C83.3898 21.1013 84.0366 21.7471 84.8346 21.7471Z"
          fill="#5681F6"
          stroke="#5681F6"
          strokeWidth="1.55738"
          strokeMiterlimit="10"
        />
        <path
          d="M169.129 36.9824C169.926 36.9824 170.573 36.3366 170.573 35.5399C170.573 34.7433 169.926 34.0975 169.129 34.0975C168.331 34.0975 167.684 34.7433 167.684 35.5399C167.684 36.3366 168.331 36.9824 169.129 36.9824Z"
          fill="white"
        />
        <path
          d="M53.5961 24.323C57.8212 24.323 61.2465 20.9033 61.2465 16.6851C61.2465 20.9033 64.6717 24.323 68.8968 24.323C64.6717 24.323 61.2465 27.7427 61.2465 31.9609C61.2465 27.7427 57.8212 24.323 53.5961 24.323Z"
          fill="white"
        />
        <path
          d="M53.5961 24.323C57.8212 24.323 61.2465 20.9033 61.2465 16.6851C61.2465 20.9033 64.6717 24.323 68.8968 24.323C64.6717 24.323 61.2465 27.7427 61.2465 31.9609C61.2465 27.7427 57.8212 24.323 53.5961 24.323Z"
          stroke="white"
          strokeWidth="1.29782"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M10.2004 131.437L20.9591 172.654L68.2002 155.71C84.1987 147.428 97.3039 134.435 105.516 118.421C107.101 115.329 108.274 112.591 108.674 110.643C110.503 101.748 123.903 66.3529 123.903 66.3529C120.27 65.4 116.294 67.3321 114.419 70.9589L109.9 78.5328C109.9 78.5328 110.918 75.2976 112.299 70.8535C114.525 63.7052 118.648 51.2391 120.059 46.2903C115.992 44.2565 110.847 46.3919 108.847 50.9415L107.746 53.4461L112.05 42.2868L115.996 32.408C111.367 30.4985 105.814 32.7846 103.291 37.643L102.778 38.6298L101.842 38.1326C97.7566 35.9633 92.4941 37.6882 89.9138 42.0457L61.7005 93.334C61.7005 93.334 58.6109 89.1912 57.9658 77.1543C57.3245 65.2042 48.618 66.2512 48.618 66.2512C48.618 66.2512 45.0908 103.201 44.2949 111.009C44.2949 111.009 43.0839 122.371 38.6514 125.565C34.2189 128.759 10.2079 131.433 10.2079 131.433L10.2004 131.437Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M109.9 78.5334L101.865 97.7561"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M82.1428 84.2087L102.778 38.6263"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M94.6443 85.6657L107.746 53.4458"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M61.6967 93.3339C61.6967 93.3339 76.4579 112.688 64.1638 129.071"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M27.4852 125.562L42.7859 168.881L15.244 184.153L0.709106 129.072L27.4852 125.562Z"
          fill="#5681F6"
          stroke="#5681F6"
          strokeWidth="1.55738"
          strokeMiterlimit="10"
        />
        <path
          d="M219.045 119.869L189.9 118.001C189.9 118.001 184.034 96.545 178.953 89.0089C173.871 81.4764 157.948 47.1399 157.948 47.1399C154.723 49.0607 153.319 53.2487 154.602 57.1241L156.85 65.6508C156.85 65.6508 155.247 62.6604 153.04 58.5628C149.487 51.9719 143.462 40.3005 140.912 35.83C136.612 37.3026 134.533 42.466 136.385 47.0796L137.404 49.6181L132.44 38.7337L128.139 29.0018C123.529 30.964 121.277 36.5192 122.986 41.7241L123.333 42.7824L122.322 43.1025C117.908 44.4923 115.46 49.4524 116.765 54.3447L132.217 112.164C132.217 112.164 129.58 108.525 122.371 98.9667C115.158 89.4081 108.681 94.5979 108.681 94.5979C108.681 94.5979 127.845 135.932 131.278 142.994C131.278 142.994 164.772 167.418 205.468 160.646L219.049 119.869H219.045Z"
          fill="white"
        />
        <path
          d="M155.145 48.4286C155.145 48.4286 157.914 56.9176 161.834 55.3659"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M111.307 92.6615C111.307 92.6615 118.64 101.377 112.978 103.663"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M152.308 55.735L164.968 84.8441"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M141.47 89.4087L121.073 38.1694"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M117.633 45.2831C117.633 45.2831 121.552 56.5629 127.177 53.0604"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M151.267 81.5222L127.501 27.9064"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M123.201 31.8227C123.201 31.8227 127.954 46.1945 134.288 42.6166"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M135.657 34.8503C135.657 34.8503 140.41 49.2221 146.744 45.6442"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M129.799 107.008L137.125 121.998"
          stroke="black"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M204.227 113.741L187.263 166.814L215.163 178.316L229.298 113.741H204.227Z"
          fill="#5681F6"
          stroke="#5681F6"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M72.1873 11.7296C74.027 11.7296 75.5183 10.2407 75.5183 8.40399C75.5183 6.56734 74.027 5.07843 72.1873 5.07843C70.3477 5.07843 68.8563 6.56734 68.8563 8.40399C68.8563 10.2407 70.3477 11.7296 72.1873 11.7296Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_554_35894">
          <rect width="230" height="185" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

EmptyTableNoResults.displayName = 'EmptyTableNoResults';

export { EmptyTableNoResults };
